// import { createTheme } from "@material-ui/core/styles";
import { createTheme } from '@mui/material/styles';
import typography from './typography';
import shadows from './shadows';

// ##############################
// Global Variables
// ##############################

const SidebarWidth = 235;
const TopbarHeight = 70;

const baseTheme = createTheme({
  direction: 'ltr',
  palette: {
    primary: {
      // main: "#1a97f5",
      main: '#2F5BEB',
      light: '#e6f4ff',
      contrastBg: '#2F5BEB29',
    },
    secondary: {
      main: '#091E420F',
    },
    background: {
      paper: '#ffffff',
      container: '#F9FBFC',
    },
    success: {
      main: '#008558',
      secondary: '#009e5c17',
      status: '#00BC7E',
    },
    danger: {
      main: '#cf3820',
      secondary: '#f5472917',
    },
    warning: {
      main: '#c65c10',
      secondary: '#ffe1cc',
      contrast: '#bf7a03',
    },
    info: {
      main: '#008cb3',
      secondary: '#008cb317',
    },
    neutral: {
      main: '#324562',
      secondary: '#78869b17',
    },
    text: {
      primary: '#2A3547',
      secondary: '#777e89',
      success: '#14C38A',
      danger: '#fc4b6c',
      grey: '#787878',
      main: '#2F5BEB',
    },
    common: {
      black: '#1A1A1A',
      white: '#FFFFFF',
    },
    purple: {
      main: '#6A329F',
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      main: '#EAEFF4',
      100: '#F2F6FA',
      200: '#EAEFF4',
      300: '#DFE5EF',
      400: '#7C8FAC',
      500: '#5A6A85',
      600: '#2A3547',
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: '#f6f9fc',
    },
    divider: '#e5eaef',
    gradient: 'linear-gradient(100.26deg, #2F5BEB 16.8%, #732BCF 97.3%)',
  },
  shape: {
    borderRadius: 5,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        root: {
          margin: 0,
        },
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          height: '100%',
          width: '100%',
        },
        body: {
          height: '100%',
          margin: 0,
          padding: 0,
        },
        '#root': {
          height: '100%',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: '15px !important',
          paddingRight: '15px !important',
          maxWidth: '1600px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        text: {
          color: '#172B4D',
          '&:hover': {
            backgroundColor: '#091E420F',
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: '9px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
          padding: '14px',
          margin: '15px',
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: '40px',
        },
      },
    },
    MuiGridItem: {
      styleOverrides: {
        root: {
          paddingTop: '30px',
          paddingLeft: '30px !important',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    // MuiToolbar: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: 'transparent',
    //       color: '#0a0a0a',
    //     },
    //   },
    // },
  },
  mixins: {
    toolbar: {
      color: '#949db2',
      '@media(min-width:1280px)': {
        minHeight: TopbarHeight,
        padding: '0 30px',
      },
      '@media(max-width:1280px)': {
        minHeight: '64px',
      },
    },
  },
  status: {
    danger: '#e53e3e',
  },
  typography,
  shadows,
});

export { TopbarHeight, SidebarWidth, baseTheme };
